module.exports = __webpack_public_path__ + "static/media/mobile-app-self-check-in-fr.ab41c7f4.png";